<template>
  <v-sheet
    height="calc(100vh - 66px)"
    class="overflow-hidden my-2 mx-2 position-relative"
  >
    <div class="d-flex h-100 position-relative">
      <div style="z-index: 9" class="position-absolute elevation-16">
        <v-expand-x-transition>
          <engineer-sidebar
            v-show="leftDrawer"
            style="min-width: 300px; max-width: 300px"
            @click:engineer="engineerMarkerClickHandler"
          />
        </v-expand-x-transition>
        <div style="position: absolute; top: 0; right: -40px; z-index: 10">
          <v-btn
            @click="leftDrawer = !leftDrawer"
            depressed
            width="40"
            min-height="40"
            ><v-icon size="35" color="blue">{{
              leftDrawer ? "mdi-chevron-left" : "mdi-chevron-right"
            }}</v-icon></v-btn
          >
        </div>
      </div>
      <div class="live-tracking-google-map">
        <div class="map-filter d-flex align-center justify-center">
          <v-checkbox
            color="cyan"
            hide-details
            v-model="showEngineers"
            style="
              background-color: white;
              min-width: 180px;
              margin: unset;
              padding: 4px 10px;
              border: solid 1px #e2e5ec;
            "
            label="Show Technician"
          />
          <v-checkbox
            color="cyan"
            v-model="showVisits"
            hide-details
            style="
              background-color: white;
              min-width: 150px;
              margin: unset;
              padding: 4px 10px;
              border: solid 1px #e2e5ec;
            "
            label="Show Visits"
            class="ml-4 mr-4"
          />
          <v-checkbox
            v-if="false"
            color="cyan"
            v-model="showRoutes"
            hide-details
            style="
              background-color: white;
              min-width: 150px;
              margin: unset;
              padding: 4px 10px;
              border: solid 1px #e2e5ec;
            "
            label="Show Routes"
            class="mr-4"
          />
          <div style="max-width: 200px">
            <DatePicker
              v-model="dateRange"
              hide-details
              color="cyan"
              style="background-color: white"
              @change="dateChanged"
            />
          </div>
        </div>
        <GmapMap
          ref="trackingGmap"
          :center="mapCenter"
          :zoom="mapZoom"
          style="width: 100%; height: 100%"
          :options="{ mapId: 'DEMO_MAP_ID' }"
        >
          <template v-if="gmapIsReady">
            <template v-if="showRoutes">
              <template v-if="showVisits && trackingVisitRoutes?.length">
                <GmapDirectionsRenderer
                  v-for="(vrow, index) in trackingVisitRoutes"
                  :key="`gmap-directions-renderer-${index}`"
                  :origin="vrow.routes.origin"
                  :destination="vrow.routes.destination"
                  :waypoints="vrow.routes.waypoints"
                  travelMode="DRIVING"
                />
              </template>
              <template v-if="showEngineers && trackingEngineerRoutes?.length">
                <GmapPolyline
                  v-for="(prow, index) in trackingEngineerRoutes"
                  :key="`gmap-polyline-${index}`"
                  :path="prow.routes"
                  :options="polyLineOption"
                />
              </template>
            </template>

            <GmapMarkerCluster
              ref="markerClusterer"
              :show-engineers="showEngineers"
              :show-visits="showVisits"
              @click:engineer="engineerMarkerClickHandler"
              @click:visit="visitMarkerClickHandler"
            />

            <GmapInfoWindow
              v-if="
                showEngineers &&
                engineerInfoWindowOpened &&
                markerEngineer?.engineer?.id
              "
              :position="markerEngineer?.position"
              :options="{ pixelOffset: { width: 0, height: -100 } }"
              class="px-0"
            >
              <div
                class="custom-info-window position-relative"
                style="min-width: 400px"
              >
                <v-toolbar
                  elevation="0"
                  :color="
                    markerEngineer?.engineer?.is_online
                      ? 'green lighten-5'
                      : 'red lighten-5'
                  "
                >
                  <v-toolbar-title class="text-h6">
                    <v-list-item>
                      <v-badge
                        bordered
                        bottom
                        :color="
                          markerEngineer?.engineer?.is_online ? 'green' : 'red'
                        "
                        dot
                        offset-x="10"
                        offset-y="10"
                        class="me-2"
                      >
                        <v-avatar size="40">
                          <v-img
                            :src="markerEngineer?.engineer?.profile_logo"
                          ></v-img>
                        </v-avatar>
                      </v-badge>
                      <v-list-item-content>
                        <v-list-item-title>{{
                          markerEngineer?.engineer?.display_name
                        }}</v-list-item-title>
                        <v-list-item-subtitle
                          >{{ markerEngineer?.engineer?.designation }}
                          <div>
                            <v-icon size="16">mdi-calendar</v-icon
                            >{{ formatDate(markerEngineer?.date) }}
                          </div></v-list-item-subtitle
                        >
                      </v-list-item-content>
                    </v-list-item>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <div class="total-visits" style="margin-right: 22px">
                    <v-btn
                      @click="closeEngineerInfoWindow"
                      icon
                      color="red"
                      class="custom-info-window-close"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <!-- Engineer Visits Summary -->
                    <div class="d-flex align-center justify-end mb-1">
                      <div class="font-weight-medium me-2">Total Visits :</div>
                      <v-avatar class="white--text" color="blue" size="25">
                        <span class="font-weight-medium">
                          {{ markerEngineer?.total_visits ?? 0 }}
                        </span>
                      </v-avatar>
                    </div>
                    <div class="d-flex align-center justify-content-end">
                      <div class="font-weight-medium me-2">
                        Overdue Visits :
                      </div>
                      <v-avatar class="white--text" color="red" size="25">
                        <span class="font-weight-medium">{{
                          markerEngineer?.overdue_visits ?? 0
                        }}</span>
                      </v-avatar>
                    </div>
                  </div>
                </v-toolbar>
                <div
                  class="px-2 py-2"
                  style="max-height: 400px; overflow-y: scroll"
                >
                  <div
                    v-if="loadingEngineer"
                    class="d-flex align-center justify-center my-4"
                  >
                    <v-progress-circular
                      :size="70"
                      :width="7"
                      color="cyan"
                      indeterminate
                    />
                  </div>
                  <template v-else>
                    <table
                      v-if="markerEngineer?.visits?.length"
                      width="100%"
                      cellpadding="0"
                      cellspacing="0"
                    >
                      <tr
                        v-for="(visit, index) in markerEngineer?.visits"
                        :key="index"
                        :class="index % 2 === 0 ? 'grey lighten-4' : ''"
                      >
                        <td>
                          <v-chip
                            :color="visit.status?.color"
                            label
                            x-small
                            text-color="white"
                          >
                            {{ visit.barcode }}
                          </v-chip>
                        </td>
                        <td width="150px">
                          <div
                            class="d-inline-block text-truncate"
                            style="max-width: 150px"
                          >
                            {{ visit.title }}
                          </div>
                        </td>
                        <td>
                          <v-icon :color="visit.status?.color" small
                            >mdi-map-marker</v-icon
                          >
                          {{ visit.property?.property_address }}
                        </td>
                        <td width="120px">
                          <div class="d-flex align-center">
                            <v-icon class="me-1" small
                              >mdi-clock-outline</v-icon
                            >
                            {{ formatTime(visit.started_at) }} -
                            {{ formatTime(visit.finished_at) }}
                          </div>
                        </td>
                      </tr>
                    </table>
                    <div v-else class="font-weight-medium text-center py-2">
                      Oops.. No visits found for this engineer.
                    </div>
                  </template>
                </div>
              </div>
            </GmapInfoWindow>

            <GmapInfoWindow
              v-if="showVisits && visitInfoWindowOpened && markerVisit?.id"
              :position="markerVisit?.property?.position"
              :options="{ pixelOffset: { width: 0, height: -100 } }"
              class="px-0"
            >
              <div
                class="custom-info-window position-relative"
                style="min-width: 300px"
              >
                <v-toolbar
                  elevation="0"
                  :color="`${markerVisit?.status_color} lighten-5`"
                >
                  <v-toolbar-title class="text-h6">
                    Job Visit: #{{ markerVisit.barcode }}
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <div class="total-visits" style="margin-right: 22px">
                    <v-btn
                      @click="closeVisitInfoWindow"
                      icon
                      color="red"
                      class="custom-info-window-close"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-icon small color="green">mdi-circle</v-icon>
                  </div>
                </v-toolbar>
                <div class="px-2 py-2">
                  <div class="d-flex align-center justify-content-start mb-2">
                    <div class="fw-600 me-1">Priority:</div>
                    <v-spacer></v-spacer>
                    <v-chip small color="green" outlined label>
                      {{ markerVisit.priority_text }}
                    </v-chip>
                  </div>
                  <div class="d-flex align-center justify-content-start mb-2">
                    <div class="fw-600 me-1">Status:</div>
                    <v-spacer></v-spacer>
                    <v-chip
                      :color="markerVisit.status_color"
                      small
                      label
                      text-color="white"
                    >
                      {{ markerVisit.status_text }}
                    </v-chip>
                  </div>
                  <div class="d-flex align-center justify-content-start mb-2">
                    <div class="fw-600 me-1">Title:</div>
                    <v-spacer></v-spacer>
                    <div>
                      {{ markerVisit.title }}
                    </div>
                  </div>
                  <div class="d-flex align-center justify-content-start mb-2">
                    <div class="fw-600 me-1">Time:</div>
                    <v-spacer></v-spacer>
                    <div class="d-flex align-center">
                      <v-icon class="me-1" small>mdi-clock-outline</v-icon>
                      {{ formatTime(markerVisit.started_at) }} -
                      {{ formatTime(markerVisit.finished_at) }}
                    </div>
                  </div>
                  <div
                    v-if="markerVisit?.engineers?.length"
                    class="d-flex align-center justify-content-start mb-2"
                  >
                    <div class="fw-600 me-1">Allocated Engineer:</div>
                    <v-spacer></v-spacer>
                    <span
                      v-for="(engineer, index) in markerVisit.engineers"
                      :key="index"
                      >{{ engineer.display_name }}
                      <span
                        class="mr-2"
                        v-if="markerVisit?.engineers[index + 1]"
                        >,</span
                      >
                    </span>
                  </div>
                </div>
              </div>
            </GmapInfoWindow>
          </template>
        </GmapMap>
        <div class="legent-list">
          <div class="mx-auto py-0" style="max-width: calc(100% - 630px)">
            <div
              class="legends d-flex flex-wrap align-center justify-left my-2"
            >
              <div
                class="px-2 mr-3 py-1 d-flex align-center border rounded"
                style="border-color: cyan"
              >
                <span class="text-black font-weight-700">Technicians :</span>
              </div>
              <div class="px-2 mr-3 py-1 d-flex align-center border rounded">
                <i
                  aria-hidden="true"
                  class="v-icon notranslate mr-1 mdi mdi-access-point theme--light green--text text--darken-1"
                  style="font-size: 15px"
                ></i
                ><span class="text-black">Online</span>
              </div>
              <div class="px-2 mr-3 py-1 d-flex align-center border rounded">
                <i
                  aria-hidden="true"
                  class="v-icon notranslate mr-1 mdi mdi-access-point theme--light red--text text--darken-1"
                  style="font-size: 15px"
                ></i
                ><span class="text-black">Offline</span>
              </div>
            </div>
            <div
              class="legends d-flex flex-wrap align-center justify-left my-2"
            >
              <div
                class="px-2 mr-3 py-1 d-flex align-center border rounded"
                style="border-color: cyan"
              >
                <span class="text-black font-weight-700">Visits :</span>
              </div>
              <div class="px-2 mr-3 py-1 d-flex align-center border rounded">
                <i
                  aria-hidden="true"
                  class="v-icon notranslate mr-1 mdi mdi-pin theme--light blue--text text--darken-1"
                  style="font-size: 15px"
                ></i
                ><span class="text-black">Open</span>
              </div>
              <div
                class="px-2 mr-3 py-1 d-flex align-center border rounded"
                style="border-color: yellow"
              >
                <i
                  aria-hidden="true"
                  class="v-icon notranslate mr-1 mdi mdi-pin theme--light yellow--text"
                  style="font-size: 15px"
                ></i
                ><span class="text-black">In-Progress</span>
              </div>
              <div class="px-2 mr-3 py-1 d-flex align-center border rounded">
                <i
                  aria-hidden="true"
                  class="v-icon notranslate mr-1 mdi mdi-pin theme--light green--text text--darken-1"
                  style="font-size: 15px"
                ></i
                ><span class="text-black">Completed</span>
              </div>
              <div class="px-2 mr-3 py-1 d-flex align-center border rounded">
                <i
                  aria-hidden="true"
                  class="v-icon notranslate mr-1 mdi mdi-pin theme--light red--text text--lighten-1"
                  style="font-size: 15px"
                ></i
                ><span class="text-black">Cancelled</span>
              </div>
            </div>
            <div class="d-flex align-center justify-content-end fw-700 mb-2">
              <span>Powered By</span>
              <v-img
                contain
                width="20"
                max-width="20"
                height="20"
                src="https://fsm-24.genicteams.com/favicon-32x32.png"
                class="mx-2"
              ></v-img>
              <span>Genic Teams</span>
            </div>
          </div>
        </div>
      </div>
      <div style="z-index: 9; right: 0" class="position-absolute elevation-16">
        <v-expand-x-transition>
          <visit-sidebar
            ref="visitSidebar"
            v-show="rightDrawer"
            style="min-width: 300px; max-width: 300px"
            @click:visit="visitMarkerClickHandler"
          />
        </v-expand-x-transition>
        <div style="position: absolute; top: 0; left: -40px; z-index: 10">
          <v-btn
            @click="rightDrawer = !rightDrawer"
            depressed
            width="40"
            min-height="40"
            ><v-icon size="35" color="blue">{{
              rightDrawer ? "mdi-chevron-right" : "mdi-chevron-left"
            }}</v-icon></v-btn
          >
        </div>
      </div>
    </div>
  </v-sheet>
</template>
<script>
import { mapGetters } from "vuex";
import EngineerSidebar from "@/view/pages/live-tracking/engineer-sidebar";
import VisitSidebar from "@/view/pages/live-tracking/visit-sidebar";
import CommonMixin from "@/core/plugins/common-mixin";
import DatePicker from "@/view/components/DatePicker.vue";
import GmapDirectionsRenderer from "@/view/pages/live-tracking/direction-renderer.vue";
import GmapMarkerCluster from "@/view/pages/live-tracking/marker-clusterer.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  SET_FILTER_DATE,
  GET_MAP_ENGINEERS,
  SET_ACTIVE_VISIT,
  GET_ENGINEERS,
  GET_ENGINEER_STATUS_LIST,
  GET_VISITS,
  GET_VISIT_STATUS_LIST,
  SET_CLEAR_FILTER_DATE,
  SET_ONLINE_STATUS,
} from "@/core/services/store/tracking.module";
import moment from "moment-timezone";
import AblyMixin from "@/core/plugins/ably.mixin";
import { gmapApi } from "vue2-google-maps";

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

const SG_LAT_LNG = {
  lat: 1.328477281032923,
  lng: 103.87715526557412,
};

const IN_LAT_LNG = {
  lat: 28.61844839427756,
  lng: 77.3776251292641,
};

const DEFAULT_LAT_LNG =
  process.env.VUE_APP_COUNTRY === "SG" ? SG_LAT_LNG : IN_LAT_LNG;

export default {
  name: "live-tracking",
  mixins: [CommonMixin, AblyMixin],
  data() {
    return {
      showEngineers: true,
      showVisits: true,
      showRoutes: false,
      leftDrawer: true,
      rightDrawer: true,
      dateRange: moment().format("YYYY-MM-DD"),
      engineerInfoWindowOpened: false,
      visitInfoWindowOpened: false,
      mapZoom: 14,
      defaultMapZoom: 14,
      mapCenter: DEFAULT_LAT_LNG,
      defaultMapCenter: DEFAULT_LAT_LNG,
      timeout: null,
      gmapIsReady: false,
      markerEngineer: {},
      markerVisit: {},
      loadingEngineer: false,
      mapListener: null,
    };
  },
  components: {
    GmapDirectionsRenderer,
    GmapMarkerCluster,
    EngineerSidebar,
    VisitSidebar,
    DatePicker,
  },
  methods: {
    onMapReady() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.gmapIsReady = true;
        this.mapListener = this.$refs.trackingGmap.$mapObject.addListener(
          "zoom_changed",
          this.closeInfoWindow
        );
      }, 500);
    },
    clearMapListener() {
      if (this.mapListener) {
        this.google.maps.event.removeListener(this.mapListener);
        this.mapListener = null;
      }
    },
    closeInfoWindow() {
      this.closeVisitInfoWindow();
      this.closeEngineerInfoWindow();
    },
    engineerMarkerClickHandler(prop) {
      this.closeInfoWindow();
      if (!prop?.id) return null;
      if (!prop?.is_tracking_enabled) return null;
      this.markerEngineer = {
        date: this.dateRange,
        type: "engineer",
        last_updated: prop.last_updated,
        last_updated_at: prop.last_updated_at,
        position: prop.position,
        total_visits: prop.total_visits,
        overdue_visits: prop.overdue_visits,
        visits: [],
        engineer: {
          id: prop.id,
          uuid: prop.uuid,
          barcode: prop.barcode,
          display_name: prop.display_name,
          is_online: prop.is_online,
          profile_logo: prop.profile_logo,
          designation: prop.designation,
        },
      };

      this.$refs.markerClusterer?.activateMarker(
        `${prop.uuid}-engineer-container`
      );
      this.loadingEngineer = true;
      this.engineerInfoWindowOpened = true;
      this.getEngineer(prop.id);
    },
    getEngineer(engineerId) {
      this.$store
        .dispatch(GET_MAP_ENGINEERS, {
          date: this.dateRange,
          engineer: engineerId,
        })
        .then((response) => {
          this.markerEngineer = response ?? {};
          this.$refs.markerClusterer?.activateMarker(
            `${this.markerEngineer?.engineer?.uuid}-engineer-container`
          );
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.loadingEngineer = false;
        });
    },
    visitMarkerClickHandler(prop) {
      if (!prop?.id) return null;
      this.markerVisit = prop;
      this.engineerInfoWindowOpened = false;
      this.visitInfoWindowOpened = true;
      this.$refs.markerClusterer?.activateMarker(
        `${prop.uuid}-visit-container`
      );
    },
    closeVisitInfoWindow() {
      this.visitInfoWindowOpened = false;
      this.markerVisit = {};
      this.mapZoom = this.defaultMapZoom;
      this.$refs.markerClusterer?.activateMarker();
      this.$store.commit(SET_ACTIVE_VISIT, {});
      // this.mapCenter = this.defaultMapCenter;
    },
    closeEngineerInfoWindow() {
      this.engineerInfoWindowOpened = false;
      this.markerEngineer = {};
      this.mapZoom = this.defaultMapZoom;
      this.$refs.markerClusterer?.activateMarker();
      this.$refs.markerClusterer?.reapplyActiveStates();
      // this.mapCenter = this.defaultMapCenter;
    },
    dateChanged() {
      if (this.trackingFilterDate !== this.dateRange) {
        this.closeInfoWindow();
        this.$store.commit(SET_CLEAR_FILTER_DATE);
        this.$refs.markerClusterer?.clearMarkerClusterer();
        this.$store.commit(SET_FILTER_DATE, this.dateRange);
        this.$store.dispatch(GET_ENGINEERS);
        this.$store.dispatch(GET_ENGINEER_STATUS_LIST);
        this.$store.dispatch(GET_VISIT_STATUS_LIST);
        this.$store.dispatch(GET_VISITS, { status: "unassigned" });
      }
    },
    getOnlineStatus(prop) {
      const { data } = prop;
      if (data?.engineerUuid) {
        for (let i = 0; i < this.trackingEngineers.length; i++) {
          const engineer = this.trackingEngineers[i];
          if (engineer?.uuid === data?.engineerUuid) {
            this.$store.commit(SET_ONLINE_STATUS, {
              key: "dbTrackingEngineers",
              index: i,
              status: data?.status ?? false,
            });
          }
        }

        for (let i = 0; i < this.trackingEnabledEngineers.length; i++) {
          const engineer = this.trackingEnabledEngineers[i];
          if (engineer?.uuid === data?.engineerUuid) {
            this.$store.commit(SET_ONLINE_STATUS, {
              key: "dbTrackingEnabledEngineers",
              index: i,
              status: data?.status ?? false,
            });
          }
        }
      }
    },
  },
  mounted() {
    this.$refs.trackingGmap?.$mapPromise?.then(this.onMapReady);

    this.channelSubscribe(
      "presence:userStatus",
      "isOnline",
      this.getOnlineStatus
    );

    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "Technician's Tracking",
      },
    ]);
  },
  beforeDestroy() {
    clearTimeout(this.timeout);

    this.clearMapListener();
    this.closeInfoWindow();

    this.channelUnsubscribe(
      "presence:userStatus",
      "isOnline",
      this.getOnlineStatus
    );
  },
  computed: {
    ...mapGetters([
      "trackingEngineerRoutes",
      "trackingVisitRoutes",
      "trackingFilterDate",
      "trackingEngineers",
      "trackingEnabledEngineers",
    ]),
    google: gmapApi,
    polyLineOption() {
      return {
        geodesic: true,
        fillColor: "#0f53ff",
        strokeColor: "#0a11d8",
        strokeOpacity: 0.7,
        strokeWeight: 4,
        icons: [
          {
            icon: { path: this.google?.maps?.SymbolPath?.CIRCLE },
            offset: "100",
            repeat: "15px",
          },
        ],
      };
    },
  },
};
</script>
